import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { select, Store } from '@ngrx/store';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getOPAddedValuesAndPumpabilities } from '../../../selectors/added-value.selectors';
import { LoadPumpabilityFilteredCatalogAction } from '../../../actions/single-catalogs.actions';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { filter, take } from 'rxjs/operators';
import { UnloadTypePumpCodesFrance } from '@ordersnproducts/modules/shared/models/pump-type.enum';

/**
 * Used only for FR
 * Filters available pumpability values for selected slump value
 */
@Injectable()
export class LoadFilteredPumpability implements OnFieldChanged {
  private pumpCodes: string[] = Object.keys(UnloadTypePumpCodesFrance).map((code) => UnloadTypePumpCodesFrance[code]);

  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        // TO-DO: REFACTOR FOR getOpenPlatformProductAddedValues('') USAGE ?? VS. MULTIPLE PRODUCT AVAILABILITY
        select(getOPAddedValuesAndPumpabilities),
        filter(
          (state) =>
            _safe(() => state.availableVaps['undefined_0'].length) > 0 &&
            !_safe(() => state.availableVaps['undefined_0'][0].loading),
        ),
        take(1),
      )
      .subscribe((state) => {
        const selectedSlump = _safe(() => formGroup.get(SpecFieldNames.SLUMP).value);
        const selectedUnloadType = formGroup.get(SpecFieldNames.UNLOAD_TYPE).value;
        const pumpabilityOptionsForSlump = {};

        // FIRST GET PUMPABILITY CODES AVAILABLE ON VAPS
        let techProdPumpabilities = [];
        Object.keys(state.availableVaps).forEach((vapKey) => {
          state.availableVaps[vapKey].forEach((vapObject) => {
            if (!!vapObject.technicalProduct && vapObject.technicalProduct.length > 0) {
              techProdPumpabilities = vapObject.technicalProduct.map((techProd) => techProd['pumpable']);
            }

            vapObject.technicalProduct.map((techProd) => {
              // SAVES AVAILABLE PUMPABILITIES ARRAY FOR THE SLUMP
              pumpabilityOptionsForSlump[techProd['slump']['slumpCode']] = _safe(
                () => pumpabilityOptionsForSlump[techProd['slump']['slumpCode']],
              )
                ? [...pumpabilityOptionsForSlump[techProd['slump']['slumpCode']], ...techProd['pumpable']]
                : [techProd['pumpable']];
            });
          });
        });

        let filteredPumpabilities = [];
        state.pumpabilities.map((pumpOptionObject) => {
          if (techProdPumpabilities.includes(pumpOptionObject.name)) {
            // VALIDATES SLUMP SELECTION FOR PUMPABILITY FILTERING
            if (!selectedSlump) {
              filteredPumpabilities.push(pumpOptionObject);
            } else if (
              pumpabilityOptionsForSlump[selectedSlump] &&
              pumpabilityOptionsForSlump[selectedSlump].includes(pumpOptionObject.name)
            ) {
              filteredPumpabilities.push(pumpOptionObject);
            }
          }
        });

        // DISCARD PUMPABILITY 0 FOR PUMPABLE UNLOAD TYPES
        if (this.pumpCodes.includes(selectedUnloadType)) {
          filteredPumpabilities = filteredPumpabilities.filter((pumpblty) => pumpblty.id !== 0);
        }

        this.store.dispatch(new LoadPumpabilityFilteredCatalogAction(filteredPumpabilities));
      });
  }
}
